module.exports = __webpack_public_path__ + "static/c1-7abf6b00f5527f77102113aa44e67df7.png";